import React, { useContext, useState } from "react";
import { Button, Col, Row } from "reactstrap";
import AppContext from "../../context/Context";
import { toast } from "react-toastify";
import APICall from "../../services/apiCall";
import Loader from "../common/Loader";

const AddTestingDemoPracticeModal = ({
  isDemoAccountSelection,
  setOpenAddDemoPracticeModal,
  activity,
  setUpdateDataFlag,
}) => {
  const [loading, setLoading] = useState(false);
  const { loginUserDetails } = useContext(AppContext);

  const handleAddingRemovingDemoPractice = () => {
    setLoading(true);
    let body = {
      master_customer_id: isDemoAccountSelection.master_customer_id,
      status: isDemoAccountSelection.is_demo_practice === "0" ? "add" : "remove",
      added_updated_by: loginUserDetails.user_name,
      is_added_updated_by_admin: loginUserDetails.is_partner === "0" ? "true" : "false",
      user_dev_id:loginUserDetails.dev_id
    };
    APICall.servertrip("POST", "demo_account", loginUserDetails, undefined, body).then(
      (res) => {
        setLoading(false);
        setUpdateDataFlag(true);
        setOpenAddDemoPracticeModal(false);
        toast.success("Successfully added the selected master customer ID as a demo practice.");
      },
      (error) => {
        const resMessage =
          (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        setLoading(false);
        toast.error(resMessage);
      }
    );
  };

  return (
    <div>
      <Col>
        <div className="alert alert-primary mt-3" role="alert">
          Are you sure you want to {isDemoAccountSelection.is_demo_practice === "0" ? "add" : "remove"} the following
          master customer id <span style={{ fontWeight: "700" }}>{isDemoAccountSelection.master_customer_id}</span> as a
          demo practice?
        </div>
      </Col>
      {loading ? (
        <Loader />
      ) : (
        <Row form className="modal-footer bg-light">
          <Button
            className="ml-auto"
            color="outline-primary"
            type="submit"
            size="sm"
            onClick={handleAddingRemovingDemoPractice}
          >
            {isDemoAccountSelection.is_demo_practice === "0" ? "Add" : "Remove"}
          </Button>
          <Button
            color="outline-secondary"
            size="sm"
            onClick={() => {
              setUpdateDataFlag(true);
              setOpenAddDemoPracticeModal(false);
            }}
          >
            Cancel
          </Button>
        </Row>
      )}
    </div>
  );
};

export default AddTestingDemoPracticeModal;
